
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import { getResourceCollectionFromContext } from "next-drupal";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import Layout from "components/Layout";
import { getGlobals } from "lib/getGlobals";
import Pager from "components/Pager";
import Header from "components/Header";
import Meta from "components/Meta";
import NodeOfficialList from "components/Official/NodeOfficialList";

export default function OfficialPage({ globals, nodes, page }) {
  const crumbs = [
    {
      path: "/",
      title: "Accueil",
    },
    {
      title: "Élus",
    },
  ];

  return (
    <Layout globals={globals} list>
      <Meta title="Les Élus" description="Retrouvez les élus de Chooz" />
      <Header crumbs={crumbs} title="Élus" />
      <section className="py-10">
        <div className="container mx-auto px-4">
          {nodes?.length ? (
            <NodeOfficialList nodes={nodes} />
          ) : (
            <p className="py-4">Aucun contenu trouvé</p>
          )}
          {page && (
            <Pager current={page.current} total={page.total} path="/elus" />
          )}
        </div>
      </section>
    </Layout>
  );
}

 async function _getStaticProps(context) {
  const params = new DrupalJsonApiParams();

  params
    .addInclude(["field_image", "field_type"])
    .addSort("field_weight", "ASC");

  const nodes = await getResourceCollectionFromContext(
    "node--official",
    context,
    {
      params: params.getQueryObject(),
    }
  );

  return {
    props: {
      globals: await getGlobals(context),
      nodes,
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/elus',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  